import { StatisticsPanel } from '@/features/statistics/ui/StatisticsPanel';

/**
 * §5: a page composes, it does not implement.
 */
export function StatisticsPage() {
  return <StatisticsPanel />;
}
